import { Head } from '@components/head';
import { Impersonator } from '@components/impersonator';
import { SimpleLayout } from '@components/ui/layouts/simple';
import { Grid } from '@mui/material';

export const ImpersonatorPage = () => {
  return (
    <SimpleLayout>
      <Head title="Impersonator" />
      <Grid container sx={{ minHeight: '100%' }}>
        <Grid
          xs={12}
          lg={12}
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Impersonator />
        </Grid>
      </Grid>
    </SimpleLayout>
  );
};
